import { PrikbordOverzichtComponent } from './prikbord-overzicht/prikbord-overzicht.component';
import { Routes } from '@angular/router';

export const prikbordRoutes : Routes = [
  { path: 'prikbord', component: PrikbordOverzichtComponent /*,resolve:{items:PrikbordItemsResolver},runGuardsAndResolvers:'paramsOrQueryParamsChange'*/ }
];

